import React from 'react';


function WhatWeDo() {
  return (
    <div className="wrapper mt-7">
      <div className="container-fluid what-we-stand">
        <div className="row">
          <div className="col-12 col-lg-6 border-dashed-bottom border-lg-dashed-bottom-0 d-flex">
            <div className="py-4">
              <h1 className="underscore font-weight-bolder my-7">What <br />we do</h1>
              <div className="display-5">
                <p>
                  We help businesses and organisations of all shapes and sizes thrive through innovation with digital products and services.
                </p>
                <p>
                  By developing our own products and applications, we strengthen open source communities that have the same goals as us.
                </p>
                <p>
                  At Emvelia we re-engineer overall experiences to achieve results that have never been scoped before.
                </p>
              </div>
            </div>
          </div>
          <div className="col-12 col-lg-6 pl-lg-9 d-flex">
            <div className="py-4">
              <h1 className="underscore font-weight-bolder mb-7">What<br />we stand for</h1>
              <div className="display-5">
                <p>
                  We are sector agnostic.
                </p>
                <p>
                  We minimise human intervention by automating human experience into more intelligent systems.
                </p>
                <p>
                  We build more sustainable, eco-friendly and energy efficient solutions that help protect the environment.
                </p>
                <p>
                  We believe in a world where humans leverage the possibilities of AI and other reactive technologies to make the world a safer place to live in.
                </p>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div className="container-fluid">
        <h1 className="font-weight-bolder underscore">Our<br />mission</h1>

      </div>

      <section className="d-flex align-items-center parallax">
        <div className="container-fluid">

          <div className="row justify-content-start align-items-center text-left">
            <div className="col-12 col-md-5">
              <h1 className="font-weight-light text-white">To improve life<br />through technology.</h1>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default WhatWeDo;


